import axios from 'axios';
import api from '@src/api';

const { CancelToken } = axios;

export const state = initialState();

// state is a function so it can be instantiated again - reset
function initialState() {
  return {
    signedPostData: [],
  };
}

export const getters = {
  hasNewMedia: (state) => (mediaType = null, modelType) => {
    return state.signedPostData.find((upload) => {
      return mediaType ? upload.type === mediaType && upload.requestType === modelType : upload.requestType === modelType;
    });
  },
};

export const mutations = {
  setSignedPostData(state, value) {
    if (value) {
      state.signedPostData.push(value);
    }
    if (!value) {
      state.signedPostData = [];
    }
  },
  setSignedPostDataUrlByIndex(state, { index, value }) {
    state.signedPostData[index].publicUrl = value;
  },
  setSignedPostDataCancelFuncByIndex(state, { index, value }) {
    state.signedPostData[index].cancel = value;
  },
  setCurrentUploadProgress(state, { index, value }) {
    state.signedPostData[index].uploadProgress = value;
  },
  setSignedPostDataSuccessByIndex(state, { index, value }) {
    state.signedPostData[index].success = value;
  },
  reset(state) {
    // acquire initial state
    const s = initialState();
    Object.keys(s).forEach((key) => {
      state[key] = s[key];
    });
  },
};

export const actions = {
  getS3UploadUrl(ctx, { file, orgId, requestType, trainerId, type }) {
    const url = api.URL_GET_ORG_S3_UPLOAD_ENDPOINT.replace(':orgID', orgId)
      .replace(':requestType', requestType)
      .replace(':trainerID', trainerId);
    return axios
      .get(url)
      .then((res) => {
        ctx.commit('setSignedPostData', {
          ...res.data.url,
          file,
          uploadProgress: 0,
          type,
          requestType,
          success: false,
          publicUrl: null,
          cancel: null,
        });
        handleMediaType(ctx, file, orgId, res.data, type, requestType);
      })
      .catch((err) => console.warn(err));
  },
  uploadPhoto(ctx, { model, option }) {
    const signedPostData = ctx.state.signedPostData.find((upload) => model === upload.requestType && option === upload.type);
    if (signedPostData) {
      // We have a specific file being requested to upload
      const uploadIndex = ctx.state.signedPostData.findIndex((upload) => model === upload.requestType && option === upload.type);
      const formData = new FormData();

      formData.append('key', signedPostData.fields.key.concat(`.${signedPostData.file.type.split('/').pop()}`));
      delete signedPostData.fields.key;
      Object.keys(signedPostData.fields).forEach((key) => formData.append(key, signedPostData.fields[key]));
      formData.append('file', signedPostData.file);

      return axios({
        method: 'POST',
        url: signedPostData.url,
        data: formData,
        cancelToken: new CancelToken(function executor(c) {
          // An executor function receives a cancel function as a parameter
          ctx.commit('setSignedPostDataCancelFuncByIndex', {
            index: uploadIndex,
            value: c,
          });
        }),
        headers: { 'Content-Type': 'multipart/form-data' },
        transformRequest: [
          (data, headers) => {
            return data;
          },
        ],
        onUploadProgress: (progressEvent) => {
          var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          ctx.commit('setCurrentUploadProgress', {
            index: uploadIndex,
            value: percentCompleted,
          });
        },
      }).then((result) => {
        if (result) {
          ctx.commit('setSignedPostDataSuccessByIndex', {
            index: uploadIndex,
            value: true,
          });
        }
      });
    } else {
      console.warn('Invalid request type and model.');
    }
  },
};

function handleMediaType(ctx, file, orgId, data, type, requestType) {
  const uploadIndex = ctx.state.signedPostData.findIndex((upload) => requestType === upload.requestType && type === upload.type);
  const filePath = data.url.fields.key.concat(`.${file.type.split('/').pop()}`);

  ctx.commit('setSignedPostDataUrlByIndex', {
    index: uploadIndex,
    value: `https://org-${orgId}.s3.amazonaws.com/${filePath}`,
  });
}
